module.exports = __webpack_public_path__ + "static/media/broccoli.24c4ef59.svg";